import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

export const Header: React.FC<{ pathPrefix: string }> = ({ pathPrefix }) => {
  const { t } = useTranslation();
  return (
    <header className="page-header">
      <Container className="content-container">
        <Row>
          <Col className="my-3 header-content">
            <a href={t("pageTitleUrl")} className="header-title">
              {t("pageTitle")}
            </a>
            <LanguageSelect pathPrefix={pathPrefix} />
          </Col>
        </Row>
      </Container>
    </header>
  );
};

const LanguageSelect: React.FC<{ pathPrefix: string }> = ({ pathPrefix }) => {
  const { t, i18n } = useTranslation();
  const languageLabel = t("languageSelect.label");

  return (
    <nav className="language-select" aria-label={languageLabel}>
      <ul>
        {["fi", "sv", "en"].map((lang) => (
          <li key={lang}>
            <Link
              to={`${lang}/${pathPrefix}`}
              lang={lang}
              className={i18n.language === lang ? "selected" : ""}
              aria-current={i18n.language === lang ? "page" : undefined}
            >
              <span className="sr-only">
                {t(`languageSelect.${lang}.screenReaderText`)}
              </span>
              <span aria-hidden="true">
                {t(`languageSelect.${lang}.abbreviation`)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
